import { SvgIcon } from "@mui/material"

export const CloseIcon = (props: any) => {
    return (
        <SvgIcon width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M0.998047 1L12.998 13M12.998 1L0.998047 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </SvgIcon>
    )
}